import React from "react";
import { useCurrentUser } from "web/hooks/useCurrentUser";
import UserAvtar from "./UserAvatar";
import useToPage from "web/hooks/useToPage";
import ArrowLeft from '../assets/arrow-left.svg?react';
import '../assets/arrow-left.svg';

export type BackTo = {
    url: string;
    pageName: string;
}

const Header = ({backTo}: {backTo?: BackTo}) => {
    const user = useCurrentUser();
    const toPage = useToPage();
    return (
        <div className='flex flex-row-reverse justify-between w-full relative z-40 rounded-xl'>
            <UserAvtar name={user.firstName + " " + user.lastName} email={user.email} />
            { backTo && (
                <a className='flex gap-[4px] cursor-pointer items-center text-[600] text-[#26818E] font-bold' href={backTo.url ?? undefined} onClick={toPage} onAuxClick={toPage}>
                    <ArrowLeft />Back to {backTo.pageName}
                </a>
            )}
        </div>
    )
}

export default Header;